import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ComponentRef, Inject, Injectable, Injector } from '@angular/core';
import { IConfigModel, INotifyPropsModel } from '@types-custom/models/ui/notify-model';
import { NotificationContainerComponent } from '@ui-core/components/notification-container/notification-container.component';

@Injectable({
  providedIn: 'root'
})
export class NotifyService {

  private overlayRef: OverlayRef | null = null;
  private notificationContainerRef: ComponentRef<any> | null = null;
  private audio: HTMLAudioElement;
  private config: IConfigModel;

  constructor(
    private overlay: Overlay,
    @Inject('environment') private environment: any
  ) { }

  loadConfig(alertProps: IConfigModel) {
    this.config = alertProps;
  }

  show(options: INotifyPropsModel) {
    if (this.overlayRef) {
      this.overlayRef.dispose();
    }

    const notifyPortal = new ComponentPortal<any>(options.component, null, this.createInjector(options));

    this.overlayRef = this.overlay.create({
      hasBackdrop: false,
      positionStrategy: this.overlay.position().global().bottom().right()
    });

    this.overlayRef.attach(notifyPortal);

    setTimeout(() => {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }, options.timeOut || 5000);
  }

  showContainer(options: INotifyPropsModel) {

    if (!this.overlayRef) {
      this.overlayRef = this.overlay.create({
        hasBackdrop: false,
        positionStrategy: this.overlay.position().global().bottom().right()
      });

      const containerPortal = new ComponentPortal(NotificationContainerComponent);
      this.notificationContainerRef = this.overlayRef.attach(containerPortal);

      this.notificationContainerRef.instance.allClosed.subscribe(() => {
        this.disposeOverlay();
      });
    }

    const notifyPortal = new ComponentPortal<any>(options.component);
    const notificationRef = this.notificationContainerRef.instance.addNotification(notifyPortal);

    if (notificationRef && notificationRef.instance) {
      notificationRef.instance.props = options.props;


      notificationRef.instance.closeEvent.subscribe(() => {
        this.closeNotification(notificationRef);
      });

      if (options.clickDispatcher) {
        notificationRef.instance.clickEvent.subscribe(options.clickDispatcher);
      }
    }

    setTimeout(() => {
      this.closeNotification(notificationRef);
    }, options.timeOut || 5000);

  }

  private closeNotification(notificationRef: ComponentRef<any>) {
    if (this.notificationContainerRef) {
      this.notificationContainerRef.instance.removeNotification(notificationRef);
      if (this.notificationContainerRef.instance.notifications.length === 0) {
        this.overlayRef?.dispose();
        this.overlayRef = null;
        this.notificationContainerRef = null;
      }
    }
  }

  closeAllNotifications() {
    if (this.notificationContainerRef) {
      this.notificationContainerRef.instance.closeAll();

    }
  }

  private disposeOverlay() {
    this.overlayRef?.dispose();
    this.overlayRef = null;
    this.notificationContainerRef = null;
  }

  private createInjector(params: INotifyPropsModel): Injector {
    return Injector.create({
      providers: [{
        provide: 'props',
        useValue: params
      }]
    });
  }

}
